/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Record_E1rmInputs */

const en_us2_exercise_sheet_record_e1rm = /** @type {(inputs: Exercise_Sheet_Record_E1rmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated max strength`)
};

const pt_br2_exercise_sheet_record_e1rm = /** @type {(inputs: Exercise_Sheet_Record_E1rmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força máxima estimada`)
};

const es_419_exercise_sheet_record_e1rm = /** @type {(inputs: Exercise_Sheet_Record_E1rmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuerza máxima estimada`)
};

const pt_pt2_exercise_sheet_record_e1rm = /** @type {(inputs: Exercise_Sheet_Record_E1rmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força máxima estimada`)
};

const fr_fr2_exercise_sheet_record_e1rm = /** @type {(inputs: Exercise_Sheet_Record_E1rmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force max estimée`)
};

const de_de2_exercise_sheet_record_e1rm = /** @type {(inputs: Exercise_Sheet_Record_E1rmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschätzte Maximalkraft`)
};

const it_it2_exercise_sheet_record_e1rm = /** @type {(inputs: Exercise_Sheet_Record_E1rmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forza massima stimata`)
};

/**
* | output |
* | --- |
* | "Estimated max strength" |
*
* @param {Exercise_Sheet_Record_E1rmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_record_e1rm = /** @type {((inputs?: Exercise_Sheet_Record_E1rmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Record_E1rmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_record_e1rm(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_record_e1rm(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_record_e1rm(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_record_e1rm(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_record_e1rm(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_record_e1rm(inputs)
	return en_us2_exercise_sheet_record_e1rm(inputs)
});
export { exercise_sheet_record_e1rm as "exercise-sheet.record_e1rm" }